import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../types";
import { Chat } from "../chat-slice";
import { Feedback } from "../contants/feedback";
import { PostChatMessagesFeedbackRequestDto } from "../../../types/dto/chat/post-chat-message-feedback-request-dto";
import { HttpStatusCode } from "axios";
import { axiosClient } from "../../../api/axios-client";
import { PostChatMessagesFeedbackResponseDto } from "../../../types/dto/chat/post-chat-message-feedback-response-dto";

export const sendFeedback = createAsyncThunk<
  // Return type of the payload creator
  Chat,
  // First argument to the payload creator
  {
    turnId: string;
    feedback: string;
  }
  // Types for ThunkAPI,
>('chat-slice/handle-new-feedback',
  async (payload, { getState, signal, fulfillWithValue, rejectWithValue }) => {
    const state = getState() as RootState;

    const reqDto: PostChatMessagesFeedbackRequestDto = {
      ip_address: state["app-state"].ipAddress,
      conversation_id: state["app-state"].conversationId,
      feedback_comment: payload.feedback,
      http_referrer: document.referrer,
      landing_page: window.location.href,
      merchant_id: state["app-state"].merchId,
      session_id: state["app-state"].sessionId,
      su_id: state["app-state"].suId,
      turn_id: payload.turnId
    };

    const response = await axiosClient.post<PostChatMessagesFeedbackResponseDto>(
      '/feedback',
      reqDto,
      {
        signal
      }
    );

    if (response.status !== HttpStatusCode.Ok) {
      // Return the known error for future handling
      return rejectWithValue((response.data));
    }

    const chatSliceStateCopy = structuredClone(state.chat);

    const targetIndex = chatSliceStateCopy.messages.findIndex((m) => m.turn_id === payload.turnId);

    // return prev if index is -1
    if (~targetIndex) {
      chatSliceStateCopy.messages[targetIndex].feedback = payload.feedback;
    }

    return fulfillWithValue(chatSliceStateCopy);
  }
)
